const validate = (values, props) => {

    let errors = {};

    if (!values.password) {
        errors.password = 'Required';
    }

    if (!values.password2 || values.password !== values.password2) {
        errors.password2 = 'Required';
    }

    return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./assets/app/login/components/ActionForm/validate.js